export const TERMS_OF_PAGES_URL = "https://corp.vacan.com/guide/terms-maps-pages-users";
